var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "aside",
        {
          staticClass: "vks-assistant-panel",
          style: _vm.panelStyle,
          attrs: {
            role: "dialog",
            "aria-modal": "false",
            "aria-labelledby": "vks-assistant-title",
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
            mousedown: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("header", { staticClass: "vks-assistant-head" }, [
            _c("div", { staticClass: "vks-assistant-head-row" }, [
              _c("h2", { attrs: { id: "vks-assistant-title" } }, [
                _vm._v("Variant Sifter assistant"),
              ]),
              _c(
                "button",
                {
                  staticClass: "vks-assistant-close",
                  attrs: {
                    type: "button",
                    "aria-label": "Close assistant",
                    disabled: _vm.executing,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(" × ")]
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "vks-ui-tabs",
                attrs: { role: "tablist", "aria-label": "Assistant sections" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "vks-ui-tab",
                    class: { "is-active": _vm.activeTab === "request" },
                    attrs: {
                      id: "vks-assistant-tab-request",
                      type: "button",
                      role: "tab",
                      "aria-selected":
                        _vm.activeTab === "request" ? "true" : "false",
                      "aria-controls": "vks-assistant-panel-request",
                      disabled: _vm.executing,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("update:activeTab", "request")
                      },
                    },
                  },
                  [_vm._v(" Request ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "vks-ui-tab",
                    class: { "is-active": _vm.activeTab === "actions" },
                    attrs: {
                      id: "vks-assistant-tab-actions",
                      type: "button",
                      role: "tab",
                      "aria-selected":
                        _vm.activeTab === "actions" ? "true" : "false",
                      "aria-controls": "vks-assistant-panel-actions",
                      disabled: _vm.executing,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("update:activeTab", "actions")
                      },
                    },
                  },
                  [_vm._v(" Actions ")]
                ),
              ]
            ),
            _vm.activeTab === "request" && !_vm.hasThread
              ? _c("p", { staticClass: "vks-assistant-autocomplete-hint" }, [
                  _vm._v(" Suggestions appear as you type. Hover or use "),
                  _c("kbd", { staticClass: "vks-assistant-kbd" }, [
                    _vm._v("↑"),
                  ]),
                  _c("kbd", { staticClass: "vks-assistant-kbd" }, [
                    _vm._v("↓"),
                  ]),
                  _vm._v(
                    " to see the full name above the list for long labels. Press "
                  ),
                  _c("kbd", { staticClass: "vks-assistant-kbd" }, [
                    _vm._v("Tab"),
                  ]),
                  _vm._v(" or "),
                  _c("kbd", { staticClass: "vks-assistant-kbd" }, [
                    _vm._v("Enter"),
                  ]),
                  _vm._v(" to accept, "),
                  _c("kbd", { staticClass: "vks-assistant-kbd" }, [
                    _vm._v("Esc"),
                  ]),
                  _vm._v(" to close. "),
                ])
              : _vm._e(),
            _vm.activeTab === "request" && !_vm.hasThread
              ? _c("p", { staticClass: "vks-assistant-intro" }, [
                  _vm._v(
                    " Describe workspace changes in plain language. Suggested steps appear here; run them when you are ready. "
                  ),
                ])
              : _vm.activeTab === "actions"
              ? _c("p", { staticClass: "vks-assistant-intro" }, [
                  _vm._v(
                    " What you can ask for on the Request tab. Type similar requests in your own words — this list does not run actions directly. "
                  ),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab === "request",
                  expression: "activeTab === 'request'",
                },
              ],
              ref: "messageScroll",
              staticClass: "vks-assistant-body",
              attrs: {
                id: "vks-assistant-panel-request",
                role: "tabpanel",
                "aria-labelledby": "vks-assistant-tab-request",
              },
            },
            [
              !_vm.hasThread
                ? _c("div", { staticClass: "vks-assistant-welcome" }, [
                    _c("p", { staticClass: "vks-assistant-welcome-lead" }, [
                      _vm._v("You can ask things like:"),
                    ]),
                    _c(
                      "ul",
                      { staticClass: "vks-assistant-examples" },
                      _vm._l(_vm.welcomeExamples, function (example, index) {
                        return _c("li", { key: `welcome-example-${index}` }, [
                          _vm._v(" " + _vm._s(example) + " "),
                        ])
                      }),
                      0
                    ),
                    _vm.llmAvailable === false
                      ? _c(
                          "p",
                          {
                            staticClass: "vks-assistant-llm-note",
                            attrs: { role: "note" },
                          },
                          [
                            _vm._v(
                              " LLM service is not available. Tissue classification uses CS2CT and does not require the LLM. "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _c(
                    "div",
                    {
                      staticClass: "vks-assistant-thread",
                      attrs: { role: "log", "aria-live": "polite" },
                    },
                    [
                      _vm._l(_vm.conversationEntries, function (entry) {
                        return _c(
                          "div",
                          {
                            key: entry.id,
                            class: [
                              "vks-assistant-message",
                              entry.role === "user"
                                ? "vks-assistant-message--user"
                                : "vks-assistant-message--assistant",
                              entry.isClarify
                                ? "vks-assistant-message--clarify"
                                : "",
                            ],
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "vks-assistant-message-label" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      entry.role === "user"
                                        ? "You"
                                        : "Assistant"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("p", [_vm._v(_vm._s(entry.text))]),
                          ]
                        )
                      }),
                      _vm.hasPlan
                        ? _c("div", { staticClass: "vks-assistant-plan" }, [
                            _c(
                              "p",
                              { staticClass: "vks-assistant-plan-title" },
                              [_vm._v("Plan")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "vks-assistant-execute-all",
                                attrs: {
                                  type: "button",
                                  disabled: !_vm.canExecutePlan,
                                },
                                on: { click: _vm.onExecuteAll },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.plan.executeLabel || "Execute") +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "ol",
                              { staticClass: "vks-assistant-steps" },
                              _vm._l(_vm.plan.steps, function (step, index) {
                                return _c(
                                  "li",
                                  {
                                    key: step.id,
                                    staticClass: "vks-assistant-step",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "vks-assistant-step-main",
                                      },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "vks-assistant-step-status",
                                          class: `is-${_vm.stepStatus(
                                            step.id
                                          )}`,
                                          attrs: {
                                            "aria-label": _vm.stepStatusLabel(
                                              step.id
                                            ),
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "vks-assistant-step-label",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(index + 1) +
                                                ". " +
                                                _vm._s(step.label) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "vks-ui-btn vks-ui-btn--secondary vks-assistant-step-run",
                                        attrs: {
                                          type: "button",
                                          disabled:
                                            _vm.executing ||
                                            !_vm.canRunActions ||
                                            _vm.stepStatus(step.id) === "done",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit(
                                              "execute-step",
                                              step.id
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" Run ")]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ])
                        : _vm._e(),
                      _vm.resultEntries.length
                        ? _c(
                            "div",
                            {
                              staticClass: "vks-assistant-results",
                              attrs: { "aria-label": "Action results" },
                            },
                            _vm._l(_vm.resultEntries, function (entry) {
                              return _c(
                                "div",
                                {
                                  key: entry.id,
                                  class: [
                                    "vks-assistant-message",
                                    "vks-assistant-message--result",
                                    entry.isClarify
                                      ? "vks-assistant-message--clarify"
                                      : "",
                                    entry.pending
                                      ? "vks-assistant-message--pending"
                                      : "",
                                  ],
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "vks-assistant-message-label",
                                    },
                                    [_vm._v("Result")]
                                  ),
                                  _c("p", [_vm._v(_vm._s(entry.text))]),
                                  entry.phenotypeGroups &&
                                  entry.phenotypeGroups.length
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "vks-assistant-phenotype-groups",
                                        },
                                        _vm._l(
                                          entry.phenotypeGroups,
                                          function (group) {
                                            return _c(
                                              "section",
                                              {
                                                key: `pheno-group-${group.ancestry}`,
                                                staticClass:
                                                  "vks-assistant-phenotype-group",
                                              },
                                              [
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "vks-assistant-phenotype-group-title",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(group.ancestry) +
                                                        " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "vks-assistant-phenotype-group-count",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " (" +
                                                            _vm._s(
                                                              group.phenotypes
                                                                .length
                                                            ) +
                                                            ") "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                group.phenotypes.length
                                                  ? _c(
                                                      "ul",
                                                      {
                                                        staticClass:
                                                          "vks-assistant-phenotype-list",
                                                      },
                                                      _vm._l(
                                                        group.phenotypes,
                                                        function (phenotype) {
                                                          return _c(
                                                            "li",
                                                            {
                                                              key: `${group.ancestry}-${phenotype.name}`,
                                                              staticClass:
                                                                "vks-assistant-phenotype-item",
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "vks-assistant-phenotype-link",
                                                                  attrs: {
                                                                    type: "button",
                                                                    disabled:
                                                                      _vm.executing,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$emit(
                                                                          "open-correlated-phenotype",
                                                                          phenotype
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        phenotype.description
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "vks-assistant-phenotype-meta",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " p=" +
                                                                      _vm._s(
                                                                        _vm.formatCorrelationP(
                                                                          phenotype.pValue
                                                                        )
                                                                      ) +
                                                                      " · Correlation=" +
                                                                      _vm._s(
                                                                        _vm.formatCorrelationRg(
                                                                          phenotype.rg
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  : _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "vks-assistant-phenotype-empty",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " None found for this ancestry. "
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm.cs2ctStarPrompt
                        ? _c(
                            "div",
                            {
                              staticClass: "vks-assistant-star-prompt",
                              attrs: {
                                role: "group",
                                "aria-label": "Star CS2CT overlap lead SNPs",
                              },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "vks-assistant-star-prompt-lead",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.cs2ctStarPrompt.message) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "ul",
                                { staticClass: "vks-assistant-star-options" },
                                [
                                  _c(
                                    "li",
                                    {
                                      staticClass: "vks-assistant-star-option",
                                    },
                                    [
                                      _c("label", [
                                        _c("input", {
                                          attrs: {
                                            type: "checkbox",
                                            disabled: _vm.executing,
                                          },
                                          domProps: {
                                            checked:
                                              _vm.allCs2ctStarOptionsSelected,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onToggleSelectAllStarOptions(
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("Select all")]),
                                      ]),
                                    ]
                                  ),
                                  _vm._l(
                                    _vm.cs2ctStarPrompt.options,
                                    function (option) {
                                      return _c(
                                        "li",
                                        {
                                          key: option.credibleSetId,
                                          staticClass:
                                            "vks-assistant-star-option",
                                        },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              attrs: {
                                                type: "checkbox",
                                                disabled: _vm.executing,
                                              },
                                              domProps: {
                                                checked:
                                                  _vm.isCs2ctStarOptionSelected(
                                                    option.credibleSetId
                                                  ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.onToggleStarOption(
                                                    option.credibleSetId,
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                            _c("span", [
                                              _vm._v(
                                                " " + _vm._s(option.label) + " "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "vks-assistant-star-option-meta",
                                                },
                                                [
                                                  _vm._v(
                                                    " (" +
                                                      _vm._s(
                                                        option.variants.length
                                                      ) +
                                                      " SNP" +
                                                      _vm._s(
                                                        option.variants
                                                          .length === 1
                                                          ? ""
                                                          : "s"
                                                      ) +
                                                      ") "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "div",
                                { staticClass: "vks-assistant-star-actions" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "vks-ui-btn vks-ui-btn--secondary",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.executing,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit("dismiss-cs2ct-star")
                                        },
                                      },
                                    },
                                    [_vm._v(" Skip ")]
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "vks-ui-btn vks-ui-btn--primary",
                                      attrs: {
                                        type: "button",
                                        disabled:
                                          _vm.executing ||
                                          !_vm.selectedCs2ctStarIds.length,
                                      },
                                      on: { click: _vm.onConfirmStarOptions },
                                    },
                                    [_vm._v(" Star selected ")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.understudiedStarPrompt
                        ? _c(
                            "div",
                            {
                              staticClass: "vks-assistant-star-prompt",
                              attrs: {
                                role: "group",
                                "aria-label":
                                  "Star understudied bottom-line variants",
                              },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "vks-assistant-star-prompt-lead",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.understudiedStarPrompt.message
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "ul",
                                {
                                  staticClass:
                                    "vks-assistant-understudied-list",
                                },
                                _vm._l(
                                  _vm.visibleUnderstudiedVariants,
                                  function (variant) {
                                    return _c(
                                      "li",
                                      {
                                        key: variant["Variant ID"],
                                        staticClass:
                                          "vks-assistant-understudied-item",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatUnderstudiedLabel(
                                                variant
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                              _vm.canExpandUnderstudiedList
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "vks-assistant-understudied-more",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.executing,
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.understudiedListExpanded = true
                                        },
                                      },
                                    },
                                    [_vm._v(" more… ")]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "vks-assistant-star-actions" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "vks-ui-btn vks-ui-btn--secondary",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.executing,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "dismiss-understudied-star"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" No ")]
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "vks-ui-btn vks-ui-btn--primary",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.executing,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "confirm-understudied-star"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" Yes ")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab === "actions",
                  expression: "activeTab === 'actions'",
                },
              ],
              staticClass: "vks-assistant-body vks-assistant-actions-panel",
              attrs: {
                id: "vks-assistant-panel-actions",
                role: "tabpanel",
                "aria-labelledby": "vks-assistant-tab-actions",
              },
            },
            _vm._l(_vm.actionCatalogSections, function (section) {
              return _c(
                "section",
                {
                  key: section.section,
                  staticClass: "vks-assistant-action-section",
                },
                [
                  _c(
                    "h2",
                    { staticClass: "vks-assistant-action-section-title" },
                    [_vm._v(_vm._s(section.section))]
                  ),
                  _c(
                    "p",
                    { staticClass: "vks-assistant-action-section-intro" },
                    [_vm._v(_vm._s(section.intro))]
                  ),
                  _vm._l(section.groups, function (group) {
                    return _c(
                      "section",
                      {
                        key: `${section.section}-${group.group}`,
                        staticClass: "vks-assistant-action-group",
                      },
                      [
                        _c(
                          "h3",
                          { staticClass: "vks-assistant-action-group-title" },
                          [_vm._v(_vm._s(group.group))]
                        ),
                        _c(
                          "ul",
                          { staticClass: "vks-assistant-action-list" },
                          _vm._l(group.actions, function (action) {
                            return _c(
                              "li",
                              {
                                key: action.id,
                                staticClass: "vks-assistant-action-item",
                                class: {
                                  "vks-assistant-action-item--runnable":
                                    section.section === "Research" &&
                                    action.runnable,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "vks-assistant-action-item-head",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "vks-assistant-action-label",
                                      },
                                      [_vm._v(_vm._s(action.label))]
                                    ),
                                    section.section === "Research" &&
                                    action.runnable
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "vks-ui-btn vks-ui-btn--primary vks-assistant-action-execute",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                _vm.executing ||
                                                !_vm.canRunActions,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.$emit(
                                                  "execute-catalog-action",
                                                  action.id
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" Execute ")]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "p",
                                  { staticClass: "vks-assistant-action-desc" },
                                  [_vm._v(_vm._s(action.description))]
                                ),
                                action.examples && action.examples.length
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "vks-assistant-action-examples-label",
                                        },
                                        [_vm._v("Example requests")]
                                      ),
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "vks-assistant-action-examples",
                                        },
                                        _vm._l(
                                          action.examples,
                                          function (example, index) {
                                            return _c(
                                              "li",
                                              { key: `${action.id}-${index}` },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(example) + " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  }),
                ],
                2
              )
            }),
            0
          ),
          _vm.activeTab === "request" && _vm.showExecutionProgress
            ? _c(
                "div",
                {
                  staticClass: "vks-assistant-execution-progress",
                  attrs: { role: "status", "aria-live": "polite" },
                },
                [
                  _c(
                    "p",
                    { staticClass: "vks-assistant-execution-progress-label" },
                    [_vm._v(_vm._s(_vm.executionProgressLabel))]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "vks-assistant-execution-progress-track",
                      attrs: {
                        role: "progressbar",
                        "aria-busy": "true",
                        "aria-label": _vm.executionProgressLabel,
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "vks-assistant-execution-progress-fill",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm.activeTab === "request"
            ? _c("footer", { staticClass: "vks-assistant-footer" }, [
                _c(
                  "label",
                  {
                    staticClass: "vks-assistant-input-label",
                    attrs: { for: "vks-assistant-input" },
                  },
                  [_vm._v(" Your request ")]
                ),
                _c("div", { staticClass: "vks-assistant-input-wrap" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.draft,
                        expression: "draft",
                      },
                    ],
                    ref: "requestInput",
                    staticClass: "vks-assistant-input",
                    attrs: {
                      id: "vks-assistant-input",
                      rows: "3",
                      disabled: _vm.executing,
                      placeholder:
                        "e.g. Zoom in, Find understudied bottom-line variants in this locus",
                      autocomplete: "off",
                      autocorrect: "off",
                      autocapitalize: "off",
                      spellcheck: "false",
                      "aria-autocomplete": "list",
                      "aria-expanded": _vm.showAutocomplete ? "true" : "false",
                      "aria-controls": "vks-assistant-suggest",
                    },
                    domProps: { value: _vm.draft },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.draft = $event.target.value
                        },
                        _vm.onDraftInput,
                      ],
                      keydown: _vm.onDraftKeydown,
                      click: _vm.updateAutocomplete,
                      focus: _vm.updateAutocomplete,
                      blur: _vm.onDraftBlur,
                    },
                  }),
                  _vm._v(" "),
                  _vm.showAutocomplete
                    ? _c("div", { staticClass: "vks-assistant-suggest-wrap" }, [
                        _vm.showSuggestionPreview
                          ? _c(
                              "div",
                              {
                                staticClass: "vks-assistant-suggest-preview",
                                attrs: {
                                  role: "status",
                                  "aria-live": "polite",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "vks-assistant-suggest-preview-label",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.previewSuggestionLabel) +
                                        " "
                                    ),
                                  ]
                                ),
                                _vm.previewSuggestionHint
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "vks-assistant-suggest-preview-hint",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.previewSuggestionHint) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "ul",
                          {
                            staticClass: "vks-assistant-suggest",
                            attrs: {
                              id: "vks-assistant-suggest",
                              role: "listbox",
                              "aria-label": "Matching assistant actions",
                            },
                          },
                          _vm._l(
                            _vm.autocompleteSuggestions,
                            function (item, index) {
                              return _c(
                                "li",
                                {
                                  key: item.id,
                                  attrs: { role: "presentation" },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "vks-assistant-suggest-item",
                                      class: {
                                        "is-active":
                                          index === _vm.suggestHighlight,
                                      },
                                      attrs: {
                                        type: "button",
                                        role: "option",
                                        "aria-selected":
                                          index === _vm.suggestHighlight
                                            ? "true"
                                            : "false",
                                        title: _vm.suggestionFullLabel(item),
                                      },
                                      on: {
                                        mouseenter: function ($event) {
                                          _vm.suggestHoverIndex = index
                                        },
                                        mouseleave: function ($event) {
                                          _vm.suggestHoverIndex = -1
                                        },
                                        mousedown: function ($event) {
                                          $event.preventDefault()
                                          return _vm.selectSuggestion(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "vks-assistant-suggest-label",
                                        },
                                        [_vm._v(_vm._s(item.label))]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "vks-assistant-suggest-hint",
                                          class: {
                                            "vks-assistant-suggest-hint--action":
                                              item.kind === "action",
                                            "vks-assistant-suggest-hint--phrase":
                                              item.kind === "phrase",
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.hint) + " ")]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c(
                  "button",
                  {
                    staticClass:
                      "vks-ui-btn vks-ui-btn--primary vks-assistant-send",
                    attrs: {
                      type: "button",
                      disabled: !_vm.draft.trim() || _vm.executing,
                    },
                    on: { click: _vm.onSubmitRequest },
                  },
                  [_vm._v(" Run ")]
                ),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }